import EntityAttackPathBaseNode from './EntityAttackPathBaseNode'
import type EntityAttackPathNode from './EntityAttackPathNode'

export default class EntityAttackPathNodeExpand extends EntityAttackPathBaseNode {
  constructor(data: Partial<EntityAttackPathNode>) {
    super()
    Object.assign(this, data)
  }
}
